import React, { useEffect, useState } from "react";
import { auth, onAuthStateChanged } from "../firebase/firebaseConfig";
import PageLoadingComponent from "../components/general/PageLoadingComponent";
import { Navigate, useLocation } from "react-router-dom";

const PublicRouter = ({ children }) => {
  const location = useLocation();
  const [logged, setLogged] = useState(null);
  const [user, setUser] = useState(null);
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setLogged(true);
        setUser(user);
      } else {
        setLogged(Boolean());
      }
    });
  });

  if (logged !== null) {
    if (user) {
      console.log(location.pathname);
      return <Navigate to="/" replace />;
    }

    return children;
  } else {
    return <PageLoadingComponent />;
  }
};

export default PublicRouter;
